import serviceUrls from 'src/constants/serviceUrls';
import { MESSAGEBOX_TYPES } from 'src/constants/constants';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchMessages(id, menu, params, config = {}) {
  const urlMap = {
    [MESSAGEBOX_TYPES.INBOX]: serviceUrls.MESSAGING_INBOX_SERVICE,
    [MESSAGEBOX_TYPES.DRAFT]: serviceUrls.MESSAGING_DRAFTS_SERVICE,
    [MESSAGEBOX_TYPES.SENT]: serviceUrls.MESSAGING_SENT_SERVICE,
  };

  const filter = !!(params.fromContact || params.toContact || params.createdOn || params.sortDirection || params.searchText);
  params.pageNumber = params.pageNumber ? params.pageNumber : 1;

  return axiosRequest(
    'post',
    urlMap[menu],
    {
      ...params,
      filter,
    },
    config,
    null,
    null,
    id,
  );
}

// export function fetchCounts() {
//   return axiosRequest('get', serviceUrls.MESSAGING_COUNT_SERVICE);
// }
export function fetchCounts(params) {
  return axiosRequest('post', serviceUrls.MESSAGING_COUNT_SERVICE, params);
}

export function fetchMessageDetails(id) {
  return axiosRequest('get', serviceUrls.MESSAGING_DETAILS_SERVICE, { messageId: id });
}

// export function delMessages(data) {
//   return axiosRequest('post', serviceUrls.MESSAGING_DELETE_SERVICE, data);
// }

export function delMessages(messages) {
  return axiosRequest('get', serviceUrls.MESSAGING_DELETE_SERVICE, { messageId: messages[0] });
}

export function delDraftMessages(messageId) {
  return axiosRequest('post', serviceUrls.MESSAGING_DELETE_DRAFT_SERVICE, { messageId });
}

export function postMessage(message) {
  return axiosRequest('post', serviceUrls.MESSAGING_SAVEMESSAGE_SERVICE, message);
}

export function searchParties(email, limit) {
  const data = {
    email,
    limit,
  };
  return axiosRequest('get', serviceUrls.MESSAGING_AUTOCOMPLETE_PARTIES, data);
}

export function getEngagements() {
  return axiosRequest('get', serviceUrls.ENGAGEMENTS_LIST);
}

export function searchCases(text, limit, isApplicant) {
  const data = {
    text,
    limit,
    isApplicant,
  };
  return axiosRequest('get', serviceUrls.MESSAGING_AUTOCOMPLETE_CASES, data);
}

export function upLoadAttachmentService(data, config) {
  return axiosRequest('post', serviceUrls.MESSAGING_UPLOAD_ATTACHMENT_SERVICE, data, config || {});
}

export function assignCaseToMessageAPI(data) {
  return axiosRequest('get', serviceUrls.MESSAGING_ASSIGN_CASE_SERVICE, data);
}

export function downloadAttachmentService(data) {
  return axiosRequest('get', serviceUrls.MESSAGING_DOWNLOAD_ATTACHMENT_SERVICE, data);
}

export function getCaseAndContactInfo(caseId, contactId, entityType) {
  const data = {
    caseId,
    contactId,
    entityType,
  };
  return axiosRequest('post', serviceUrls.MESSAGING_GET_CASE_CONTACT_INFO, data);
}

export function fetchFilters(data) {
  return axiosRequest('post', serviceUrls.MESSAGING_FILTERS, data);
}
